// Odpowiednik App\Services\Utils\TableCellText::lines() - lamanie tekstu komorki
// co $lineMax znakow, zeby tabele Vue zawijaly sie tak samo jak listy w Blade.

/** Fragmenty slow krotsze niz to przechodza do nastepnej linii zamiast byc ciete. */
const MIN_FRAGMENT = 10;

export const normalize = (text) => {
    return text === null || text === undefined ? '' : String(text).replace(/\s+/g, ' ').trim();
};

export const lines = (text, lineMax, wrapOnSpace = true) => {
    let rest = normalize(text);
    const result = [];

    while (rest.length > lineMax) {
        const line = rest.substring(0, lineMax);
        const next = rest.charAt(lineMax);
        let breakAt = lineMax;

        if (next !== ' ' && line.slice(-1) !== ' ') {
            const lastSpace = line.lastIndexOf(' ');
            if (wrapOnSpace && lastSpace !== -1 && lineMax - (lastSpace + 1) < MIN_FRAGMENT) {
                breakAt = lastSpace;
            }
        }

        result.push(rest.substring(0, breakAt).trimEnd());
        rest = rest.substring(breakAt).trimStart();
    }

    if (rest !== '') {
        result.push(rest);
    }

    return result;
};

export default {normalize, lines};
